import { SIDEBAR_DRAWER_CLASS_NAME, NAV_DRAWER_CLASS_NAME } from '../../constants/drawer';

const DRAWER_WIDTH = 190;

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const sidebarDrawer = ({ theme, ownerState }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(ownerState?.open && {
    ...openedMixin(theme),
  }),
  ...(!ownerState?.open && {
    ...closedMixin(theme),
  }),
  '& .MuiDrawer-paper': {
    position: 'inherit',
    backgroundColor: 'transparent',
    border: 0,
    ...(ownerState?.open && openedMixin(theme)),
    ...(!ownerState?.open && closedMixin(theme)),
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
    width: 0,
  },
});

const navDrawer = (theme) => ({
  '& .MuiDrawer-paper': {
    minWidth: 280,
    backgroundColor: theme.palette.text.primary,
    paddingBottom: theme.spacing(4),
  }
});

const MuiDrawer = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      [`&.${SIDEBAR_DRAWER_CLASS_NAME}`]: sidebarDrawer({ theme, ownerState }),
      [`&.${NAV_DRAWER_CLASS_NAME}`]: navDrawer(theme),
    }),
  },
};

export default MuiDrawer;
